import { Component, OnInit } from '@angular/core';
import { HttpService } from '../../http.service';
import { GlobalService } from '../../global.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, ProgressSpinnerMode, ThemePalette } from '@angular/material';
import { ByProductListAddComponent } from '../by-product-list-add/by-product-list-add.component';

@Component({
  selector: 'app-by-product-list',
  templateUrl: './by-product-list.component.html',
  styleUrls: ['./by-product-list.component.scss']
})
export class ByProductListComponent implements OnInit {
  product_register_form: FormGroup;
  by_product_group_list: any;
  by_product_dict: any;
  title = '';
  show_add_product_page = false;
  unit_list = [];
  action = '';
  page_header = '';
  is_data_available: boolean = true;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';

  constructor(private httpService: HttpService, private globalService: GlobalService, private formBuilder: FormBuilder, public dialog: MatDialog) {
    this.title = this.globalService._active_display_name;
    this.product_register_form = this.formBuilder.group({
      id: [null, Validators.compose([])],
      group_id: [null, Validators.compose([Validators.required])],
      name: [null, Validators.compose([Validators.required])],
      product_code: [null, Validators.compose([Validators.required])],
      quantity: [null, Validators.compose([Validators.required])],
      unit_id: [null, Validators.compose([Validators.required])],
      base_price: [null, Validators.compose([Validators.required])],
      igst_percent: [0, Validators.compose([])],
      cgst_percent: [null, Validators.compose([])],
      sgst_percent: [null, Validators.compose([])],
      display_ordinal: [null, Validators.compose([Validators.required])],
      igst_amount: [0, Validators.compose([Validators.required])],
      cgst_amount: [null, Validators.compose([Validators.required])],
      sgst_amount: [null, Validators.compose([Validators.required])],
      mrp: [null, Validators.compose([Validators.required])],
      description: [null, Validators.compose([])],
    });
    this.product_register_form.get('cgst_percent').valueChanges.subscribe(() => {
      this.calculateIGST();
    })
    this.product_register_form.get('sgst_percent').valueChanges.subscribe(() => {
      this.calculateIGST();
    })
    this.product_register_form.get('cgst_percent').valueChanges.subscribe(() => {
      this.calculateIGSTAmount();
    })
    this.product_register_form.get('sgst_amount').valueChanges.subscribe(() => {
      this.calculateIGSTAmount();
    })

    this.serveProductList();
  }

  calculateIGSTAmount() {
    let sgst_amount: any = 0;
    let cgst_amount: any = 0;
    if (this.product_register_form.get('sgst_amount').value != null) {
      sgst_amount = this.product_register_form.get('sgst_amount').value;
    }
    if (this.product_register_form.get('cgst_amount').value != null) {
      cgst_amount = this.product_register_form.get('cgst_amount').value;
    }
    let igst_amount: any = parseFloat(sgst_amount) + parseFloat(cgst_amount);
    igst_amount = igst_amount;
    this.product_register_form.get('igst_amount').setValue(igst_amount);
  }

  calculateIGST() {
    let sgst_percent: any = 0;
    let cgst_percent: any = 0;
    if (this.product_register_form.get('sgst_percent').value != null) {
      sgst_percent = this.product_register_form.get('sgst_percent').value;
    }
    if (this.product_register_form.get('cgst_percent').value != null) {
      cgst_percent = this.product_register_form.get('cgst_percent').value;
    }
    let igst_percent: any = parseFloat(sgst_percent) + parseFloat(cgst_percent);
    igst_percent = igst_percent.toFixed(3);
    this.product_register_form.get('igst_percent').setValue(igst_percent);
  }

  registerOrUpdateProduct() {
    console.log(this.product_register_form.value);
    this.httpService.registerOrUpdateByProduct(this.product_register_form.value).subscribe((data) => {
      console.log(data);
      this.serveProductList();
      this.show_add_product_page = false;
    }, (error) => {
      console.error(error);
    });
  }

  enableProductAddPage(action, product = null) {
    this.product_register_form.reset();
    this.show_add_product_page = !this.show_add_product_page;
    this.action = action;
    if (action == 'Update') {
      this.page_header = 'Update Product';
      this.product_register_form.get('id').setValue(product['id']);
      this.product_register_form.get('group_id').setValue(product['product_group']);
      this.product_register_form.get('name').setValue(product['name']);
      this.product_register_form.get('display_ordinal').setValue(product['display_ordinal']);
      this.product_register_form.get('product_code').setValue(product['product_code']);
      this.product_register_form.get('quantity').setValue(product['quantity']);
      this.product_register_form.get('unit_id').setValue(product['unit_id']);
      this.product_register_form.get('base_price').setValue(product['base_price']);
      this.product_register_form.get('igst_percent').setValue(product['igst_percent']);
      this.product_register_form.get('sgst_percent').setValue(product['sgst_percent']);
      this.product_register_form.get('cgst_percent').setValue(product['cgst_percent']);
      this.product_register_form.get('igst_amount').setValue(product['igst_amount']);
      this.product_register_form.get('sgst_amount').setValue(product['sgst_amount']);
      this.product_register_form.get('cgst_amount').setValue(product['cgst_amount']);
      this.product_register_form.get('mrp').setValue(product['mrp']);
      this.product_register_form.get('description').setValue(product['description']);
    } else {
      this.page_header = 'Add New Product';
    }

  }


  openDialog(): void {
    this.dialog.open(ByProductListAddComponent, {
      width: '400px', // Set the width of the dialog
    });
  }


  checkDisable() {
    if (this.action == 'Update') {
      return true;
    } else {
      return null;
    }
  }

  valueChanged(event) {
    // let sgst_percent = this.product_register_form.get('sgst_percent').value;
    // let cgst_percent = this.product_register_form.get('cgst_percent').value;
    // let igst_percent = parseFloat(sgst_percent) + parseFloat(cgst_percent);
    // console.log(igst_percent);
    // this.product_register_form.get('igst_percent').setValue(igst_percent)
  }

  serveProductList() {
    this.is_data_available = false;
    this.httpService.serveByProductList().subscribe((data) => {
      console.log(data);
      this.by_product_group_list = data["by_product_group_list"];
      this.by_product_dict = data["by_product_dict"];
      this.unit_list = data['unit_list'];
      this.is_data_available = true;
    }, (error) => {
      this.is_data_available = true;
      console.error(error);
    });
  }

  ngOnInit() {
  }

}
